import React from 'react'
import StepTemplate from './StepTemplate'
import { Pregunta, PREGUNTAS } from '../../data/ocean'

const CONSIGNAS: Pregunta[] = PREGUNTAS.slice(0, 11)

export default function Step1() {
  return <StepTemplate step={1} consignas={CONSIGNAS} />
}
